export default __webpack_public_path__ + "static/media/icon_aboutus.6387dcf8.svg";